var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'avatar-operations': true,
    incoming: _vm.incoming,
    outgoing: !_vm.incoming,
  }},[(_vm.incoming)?_c('v-btn',{staticClass:"ma-0 pa-0",attrs:{"id":"btn-private-chat","text":""},on:{"click":function($event){$event.stopPropagation();return _vm.startPrivateChat.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t("menu.start_private_chat")))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }